import ctl from "@netlify/classnames-template-literals";

export const contentWrapper = ctl(`
  rounded-2xl
  px-4
  md:px-8
  flex
  flex-col
  md:flex-row
  gap-4
  md:gap-8
  items-center
  mt-7
  py-4
  md:py-0
`);

export const imageWrapper = ctl(`
   relative
   w-[80px]
   md:w-[100px]
   flex-shrink-0
   self-center
   md:self-end
   drop-shadow-md
`);

export const textWrapper = ctl(`
   w-full
   py-0
   md:py-4
   flex
   items-center
   justify-center
   md:justify-between
   flex-col
   gap-4
   md:gap-0
   md:flex-row
`);

export const linksWrapper = ctl(`
   flex
   items-center
   gap-2
   md:gap-4
   md:ml-16
   flex-shrink-0
   flex-col
   md:flex-row
`);

export const linksInnerWrapper = ctl(`
   flex
   flex-row
   md:flex-col
   gap-2
   md:gap-1
   justify-center
   items-center
   order-1
   md:order-2
`);
